import React from 'react';
import { dateFn } from '../../utils/dateTimeFormatter';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { CalendarIcon, CheckCircleIcon } from '@heroicons/react/24/outline';

export default function OrderPlaced() {
  const navigate = useNavigate();
  const { profileData } = useSelector((state) => state.profile);
  const { orderDetails, availableServices } = useSelector((state) => state.group);

  return (
    <div className='mx-auto max-w-md rounded-2xl bg-white p-6 text-center shadow'>
      <div className='text-client-800 mb-1 text-lg font-bold'>Thanks, {profileData?.first_name}!</div>
      <div className='text-client-800 mb-1 text-lg font-bold'>Order #{orderDetails?.orderId} Created</div>
      <div className='mb-4 text-base'>
        <span role='img' aria-label='room'>
          📍
        </span>
        <span className='text-client-800 ml-1 font-semibold'>{profileData?.addresses[0]?.full_address}</span>
      </div>
      <hr className='border-client-800 mb-4 border-dashed' />
      <div className='mx-auto mb-4'>
        <div className='mb-4 flex items-start'>
          <span className='mr-2'>
            <CalendarIcon className='h-6 w-6 text-gray-700' />
          </span>
          <div className='text-left'>
            <div className='font-medium text-gray-500'>Pickup</div>
            <div className='font-medium text-gray-800'>
              {dateFn(
                'toLocal',
                orderDetails?.payload?.pickup_date,
                orderDetails?.payload?.pickup_start_time,
                orderDetails?.payload?.pickup_end_time,
                profileData?.addresses[0]?.time_zone
              )}
            </div>
          </div>
        </div>
        {/* Delivery */}
        <div className='mb-4 flex items-start'>
          <span className='mr-2'>
            <CalendarIcon className='h-6 w-6 text-gray-700' />
          </span>
          <div className='text-left'>
            <div className='font-medium text-gray-500'>Delivery</div>
            <div className='font-medium text-gray-800'>
              {dateFn(
                'toLocal',
                orderDetails?.payload?.dropoff_date,
                orderDetails?.payload?.dropoff_start_time,
                orderDetails?.payload?.dropoff_end_time,
                profileData?.addresses[0]?.time_zone
              )}
            </div>
          </div>
        </div>
      </div>
      <hr className='border-client-800 mb-4 border-dashed' />
      {/* Services */}
      <div className='mx-auto mb-4'>
        <div className='mb-4'>
          {orderDetails?.payload?.items.map((s, i) => (
            <div key={i} className='mb-2 flex items-start'>
              <span className='mr-2 text-blue-700'>
                <CheckCircleIcon className='h-6 w-6 text-gray-700' />
              </span>
              <div className='text-left'>
                <div className='font-medium text-gray-800'>
                  {availableServices?.find((service) => service.id === s.service_id)?.service}
                </div>
                <div className='text-sm text-gray-500'>({s.quantity})</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className='text-client-800 mb-2 text-sm font-bold'>A confirmation will be sent to your email</div>
      <button
        className='hover:bg-client-lcpink mt-2 w-full rounded-full bg-pink-400 py-3 text-lg font-medium text-white transition'
        type='button'
        onClick={() => navigate(`/order/${orderDetails?.orderId}`)}
      >
        View Order
      </button>
    </div>
  );
}
